// import store from "@/store";
import { Roles, type Role } from "best-of-awards-api";
import { useCategoriesStore, useTagsStore, useUsersStore } from "@/stores";

export default function (role: Role) {
  return fns[role]();
}

const fns = {
  [Roles.Admin]: () => {
    const categoriesStore = useCategoriesStore();
    const tagsStore = useTagsStore();
    const usersStore = useUsersStore();
    return Promise.all([
      categoriesStore.getCategories(),
      tagsStore.getTagGroups(),
      tagsStore.getTags(),
      usersStore.getUserGroups(),
    ]);
  },
  [Roles.Candidate]: () => {
    // const categoriesStore = useCategoriesStore();
    // const tagsStore = useTagsStore();
    // return Promise.all([
    //   categoriesStore.getCategories(),
    //   tagsStore.getTagGroups(),
    //   tagsStore.getTags(),
    // ]);
  },
};
